module.exports = __webpack_public_path__ + "img/stage-5.90d8881f.png";